import React, { useEffect, useState } from "react"
import Accordion from "@mui/material/Accordion"
import AccordionSummary from "@mui/material/AccordionSummary"
import AccordionDetails from "@mui/material/AccordionDetails"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import Button from "react-bootstrap/Button"
import { styled } from "@mui/material/styles"
import { useLocation } from "react-router"
import { getAllChemoOrders, startChemoOrder, deleteChemoOrder } from "../../../../core/services/api"
import AccordianOrderDetail from "./AccordianOrderDetail"
import EditIcon from "@mui/icons-material/Edit"
import Buttons from "@mui/material/Button"
import Toast from "../../../Toast"
import AddNewChemoOrder from "./AddNewChemoOrder"
import moment from "moment"

const CustomAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: "#AFC4FF",
  borderBottom: 0,
}))

function PendingOrder({ patientInfo, readOnly, smartSummaryDetails, appointmentDetails }: any) {
  const [allOrders, setallOrders] = useState([])
  const [showForm, setshowForm] = useState<boolean>(false)
  const location = useLocation()
  const appointmentId = new URLSearchParams(location.search).get(
    "appointmentId"
  )

  const [displayToast, toggleDisplayToast] = useState<any>()
  const [refresh, setrefresh] = useState<any>(false)

  useEffect(() => {
    const event = "UPCOMING"
    getAllChemoOrders(patientInfo?.id, event).then((res) => {
      // res?.sort((a: any, b: any) => new Date(b?.chemoOrderForDate)?.getTime() - new Date(a?.chemoOrderForDate)?.getTime());
      setallOrders(res)
    })
  }, [refresh])


  function startOrder(values: any) {
    startChemoOrder(values?.therapyId, values?.id, appointmentId ?? "")
      .then((res: any) => {
        toggleDisplayToast({
          text: "Therapy started successfully",
          type: "success"
        })
        setrefresh((current: any) => !current);
      })
      .catch((err: any) => {
        console.log(err, "err Cannot start chemo therapy .")
        console.log(err.text, "err text");
        toggleDisplayToast({
          text: `${err.response.data.message}`,
          type: "error"
        })
      })
  }

  function deleteOrder(values: any) {
    toggleDisplayToast({
      text: `Are you sure you want to delete this order?`,
      type: "warning",
      onClickText: "Yes",
      values: values,
    })
  }


  return (
    <div
      style={readOnly ? { cursor: 'not-allowed' } : {}}
      className="completed-chemo" >
      {/* <div className="create-heading" style={{ paddingBottom: "20px" }}>
        Create Chemo order for date
      </div> */}
      {allOrders?.map((values: any, index: any) => {
        return (
          <CustomAccordion
            sx={{
              "&:before": {
                display: "none",
              },
              // borderRadius: "20px",
              // margin: "20px",
              marginTop: "10px",
              borderRadius: "10px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="accordian-heading">
                <div className="accordian-child">Chemo Order</div>
                <div className="accordian-child">cycle {values?.cycleNo}</div>
                <div className="accordian-child">{values?.regimen}</div>
                <div className="accordian-child">
                  {values?.chemoOrderForDate ? moment(values?.chemoOrderForDate)?.format("DD-MM-YYYY") : "-"}
                </div>
                <div className="accordian-child">
                  {patientInfo?.centers[0]?.centerName}
                </div>
                <div className="accordian-child" style={{ flex: 2 }}>
                  {patientInfo?.primaryConsultantName}
                </div>

              </div>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: "#f7f8fa" }}>
              <div className="edit-icon-parent">
                <div>
                  {values?.isEditable === true ? (

                    <Buttons
                      variant="text"
                      sx={{
                        color: "black",
                        fontWeight: "600",
                      }}
                      onClick={(event: any) => {
                        event.stopPropagation();
                        setshowForm((current) => !current);
                      }}
                      startIcon={<EditIcon sx={{ color: "black" }} />}
                    ></Buttons>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              {showForm ? (
                <div>
                  <AddNewChemoOrder
                    patientInfo={patientInfo}
                    order={values}
                    isEditableOrder={values.isEditable}
                    readOnly={readOnly}
                    smartSummaryDetails={smartSummaryDetails}
                    appointmentId={appointmentId}
                    appointment={appointmentDetails}
                    redirectPendingOrder={(val: any) => {
                      //setValue(val);
                    }}
                    handleChemoOrderUpdation={(val: any) => {
                      console.log(val, "val in Pending Order ");
                      setrefresh((val: any) => !val);
                    }
                    }
                    pendingOrDelete={true}
                  />
                </div>
              ) : (
                <div>
                  <div style={{ display: 'flex', marginTop: '20px', marginBottom: '20px' }}>
                    {values.isActive || values.isCompleted ? (
                      <Button
                        onClick={() => {
                          startOrder(values)
                        }}
                        disabled
                        style={{
                          backgroundColor: '#1ec069',
                          border: '2px solid #1ec069',

                        }}>
                        Start Order
                      </Button>
                    ) : (
                      <div>
                        {readOnly ? (<> <Button
                          onClick={() => {
                            startOrder(values)
                          }}
                          disabled
                          style={{
                            backgroundColor: '#1ec069',
                            border: '2px solid #1ec069',
                          }}>
                          Start Order
                        </Button></>) : (<>  <Button
                          onClick={() => {
                            startOrder(values)
                          }}
                          style={{
                            backgroundColor: '#1ec069',
                            border: '2px solid #1ec069',
                          }}>
                          Start Order
                        </Button></>)}

                      </div>)
                    }

                    {readOnly ? (<></>) : (<><Button
                      style={{ marginLeft: '15px', cursor: 'pointer' }}
                      variant="danger"
                      onClick={() => {
                        deleteOrder(values)
                      }}>
                      Delete Order

                    </Button></>)}

                    <hr />
                    {
                      (values?.isActive || values?.isCompleted) && (
                        <div className="chemo-details-row1">
                          <div className="accordian-details-sub">
                            <div className="details-general-sub-label">Appointment ID:</div>
                            <div className="details-general-sub-value">{appointmentDetails?.mocAppointmentId}</div>
                          </div>
                        </div>
                      )
                    }
                  </div>
                  <AccordianOrderDetail
                    patientInfo={patientInfo}
                    values={values}
                    readOnly={readOnly}
                    appointmentDate={appointmentDetails?.scheduleDate}
                    isCompleted={values.isCompleted}
                    handleChemoOrderCompletion={(val: any) => {
                      setrefresh((val: any) => !val);
                    }}
                    type="UPCOMING"
                    smartSummaryData={smartSummaryDetails}
                  />
                </div>
              )}
            </AccordionDetails>
          </CustomAccordion>
        )
      })}
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          onClose={() => {
            toggleDisplayToast(false)
          }}
          type={displayToast?.type}
          onCloseText="Close"
          onClickText={displayToast?.onClickText || null}
          onClick={() => {
            toggleDisplayToast(false)
            deleteChemoOrder(displayToast?.values?.therapyId, displayToast?.values?.id)
              .then((res: any) => {
                toggleDisplayToast({ text: "Order Deleted successfully", type: "success" });
                setrefresh((current: any) => !current);
              })
              .catch((err: any) => {
                toggleDisplayToast({ text: "Unable to delete Order", type: "error" });
              });

          }
          }
        />
      )}
    </div>

  )
}

export default PendingOrder
